var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "qr-generator-container" }, [
    _c("div", { staticClass: "control-panel" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("label", { staticStyle: { flex: "none" } }, [_vm._v("背景图片:")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "file", accept: "image/*" },
          on: { change: _vm.handleBgImageUpload },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { staticStyle: { flex: "none" } }, [_vm._v("Logo图片:")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "file", accept: "image/*", disabled: _vm.canSelect },
          on: { change: _vm.handleLogoUpload },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm.logoImage
          ? _c("div", { staticClass: "logo-preview" }, [
              _c("label", [_vm._v("Logo预览:")]),
              _vm._v(" "),
              _c("img", {
                staticStyle: { "max-width": "50px", "max-height": "50px" },
                attrs: { src: _vm.logoImage.src },
              }),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("底部文字:")]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.footerText,
              expression: "footerText",
            },
          ],
          attrs: { rows: "3", placeholder: "输入底部文字" },
          domProps: { value: _vm.footerText },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.footerText = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("文字颜色:")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.textColor,
              expression: "textColor",
            },
          ],
          attrs: { type: "color" },
          domProps: { value: _vm.textColor },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.textColor = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("文字大小:")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.textSize,
              expression: "textSize",
              modifiers: { number: true },
            },
          ],
          attrs: { type: "range", min: "12", max: "50" },
          domProps: { value: _vm.textSize },
          on: {
            __r: function ($event) {
              _vm.textSize = _vm._n($event.target.value)
            },
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.textSize) + "px")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("二维码大小:")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.qrSize,
              expression: "qrSize",
              modifiers: { number: true },
            },
          ],
          attrs: { type: "range", min: "100", max: "1000" },
          domProps: { value: _vm.qrSize },
          on: {
            __r: function ($event) {
              _vm.qrSize = _vm._n($event.target.value)
            },
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.qrSize) + "px")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("二维码X位置:")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.qrPosition.x,
              expression: "qrPosition.x",
              modifiers: { number: true },
            },
          ],
          attrs: { type: "range", min: "0", max: _vm.canvasWidth },
          domProps: { value: _vm.qrPosition.x },
          on: {
            __r: function ($event) {
              _vm.$set(_vm.qrPosition, "x", _vm._n($event.target.value))
            },
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.qrPosition.x) + "px")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("二维码Y位置:")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.qrPosition.y,
              expression: "qrPosition.y",
              modifiers: { number: true },
            },
          ],
          attrs: { type: "range", min: "0", max: _vm.canvasHeight },
          domProps: { value: _vm.qrPosition.y },
          on: {
            __r: function ($event) {
              _vm.$set(_vm.qrPosition, "y", _vm._n($event.target.value))
            },
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.qrPosition.y) + "px")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("文案X位置:")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.qrPosition1.x,
              expression: "qrPosition1.x",
              modifiers: { number: true },
            },
          ],
          attrs: { type: "range", min: "0", max: _vm.canvasWidth },
          domProps: { value: _vm.qrPosition1.x },
          on: {
            __r: function ($event) {
              _vm.$set(_vm.qrPosition1, "x", _vm._n($event.target.value))
            },
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.qrPosition1.x) + "px")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("文案Y位置:")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.qrPosition1.y,
              expression: "qrPosition1.y",
              modifiers: { number: true },
            },
          ],
          attrs: { type: "range", min: "0", max: _vm.canvasHeight },
          domProps: { value: _vm.qrPosition1.y },
          on: {
            __r: function ($event) {
              _vm.$set(_vm.qrPosition1, "y", _vm._n($event.target.value))
            },
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.qrPosition1.y) + "px")]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "align-items": "center",
            "justify-content": "space-evenly",
          },
        },
        [
          _c(
            "button",
            {
              staticClass: "generate-btn",
              on: { click: _vm.generateAndDownload },
            },
            [_vm._v("\n        生成并下载\n      ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "generate-btn",
              staticStyle: {
                background: "transparent",
                color: "black",
                border: "1px solid #000",
                "box-sizing": "border-box",
              },
              on: { click: _vm.reset },
            },
            [_vm._v("\n        重置\n      ")]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "preview-area" }, [
      _c("canvas", {
        ref: "previewCanvas",
        staticStyle: { "max-width": "100%", height: "auto", zoom: "35%" },
        attrs: { width: _vm.canvasWidth, height: _vm.canvasHeight },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }